<template>
  <section class="financement section">
    <div class="container">
      <h2 class="title has-text-primary padtop" id="financement">Financement</h2>
      <div class="founders m-6 columns">
        <div class="column is-half">
          <div data-aos="fade-up">
            <p class="is-size-5 founders-intro">
              Ce projet Interreg North-West Europe est financé par les fonds
              européens FEDER et la Wallonie via l'intermédiaire de l'agence
              pour une vie de qualité (AVIQ).
            </p>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div data-aos="fade-up" data-aos-delay="100">
            <a 
              href="https://www.nweurope.eu/projects/project-search/it4anxiety-managing-anxiety-via-innovative-technologies-for-better-mental-health/"
              target="_blank"
            >
              <figure class="logo_feder">
                <img src="../assets/img/logo_feder.png" alt="logo feder" />
              </figure>
            </a>
          </div>
        </div>
        <div class="column is-one-quarter">
          <div data-aos="fade-up" data-aos-delay="200">
            <a href="https://www.aviq.be" target="_blank">
              <img src="../assets/img/aviq.png" alt="logo AViQ - Agence pour une Vie de Qualité" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.logo_feder{
  // border:1px solid red!important;
  padding: 0 30px 0;
  display:block;
}
</style>